var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "pr-0 md:pr-4 w-full md:w-auto py-10 md:py-0" },
    [
      _c(
        "ul",
        {
          staticClass:
            "overflow-hidden list-reset flex items-center justify-between md:justify-center md:block",
        },
        [
          _c(
            "RegisterStepListItem",
            _vm._b({}, "RegisterStepListItem", _vm.stepsConfig.register, false),
            [_vm._v("\n      Create an account\n    ")]
          ),
          _vm._v(" "),
          _c(
            "RegisterStepListItem",
            _vm._b({}, "RegisterStepListItem", _vm.stepsConfig.profile, false),
            [_vm._v("\n      Build your profile\n    ")]
          ),
          _vm._v(" "),
          _c(
            "RegisterStepListItem",
            _vm._b({}, "RegisterStepListItem", _vm.stepsConfig.jedi, false),
            [_vm._v("\n      Take the J.E.D.I. pledge\n    ")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }